import { ShippingCarriers } from "../shippingCarriers";
import { ShippingService } from "../shippingRates.types";
import Big from "big.js";
import { getPricesWithoutVAT } from "../utils";



export const temu_fedex: ShippingService = {
  serviceCode: 'temu_fedex',
  description: 'Buying on Temu shipping, FedEx pickup',
  deliveryType: 'home',
  carrier: ShippingCarriers.fedex,
  appliesVolumetricWeight: true,
  conditions: {
    orderPlatform: 'temu',
  },
  maxDimensions: (size1: number, size2: number, size3: number, weight: number) => {
    const sortedSizes = [size1, size2, size3].sort((a, b) => b - a);
    const calculation = sortedSizes[0] + 2 * (sortedSizes[1] + sortedSizes[2]);
    if (calculation > 266) {
      return { isValid: false, errorMessage: 'Max dimensions exceeded (266cm). Calculation is Length + 2 * (Width + Height)' };
    }

    const volumetricWeight = (
      new Big(size1 * size2 * size3).div(5000).times(1000)
    );
    if (volumetricWeight.gt(25000)) {
      return { isValid: false, errorMessage: 'Max volumetric weight exceeded (25kg).' };
    }

    if (weight > 25000) {
      return { isValid: false, errorMessage: 'Max weight exceeded (25kg).' };
    }

    if (sortedSizes[0] > 121) {
      return { isValid: false, errorMessage: 'Max length exceeded (121cm).' };
    }

    if (sortedSizes[1] > 76) {
      return { isValid: false, errorMessage: 'Max width exceeded (76cm).' };
    }
    return { isValid: true, errorMessage: '' };
  },
  // TODO: get exact calculations
  ratesByDestination: [
    {
      destinations: ['DE', 'BE', 'LU', 'ES', 'IT', 'NL'],
      rates: [
        {
          minWeight: 0,
          maxWeight: 500,
          ...getPricesWithoutVAT(4.75),
        },
        {
          minWeight: 500,
          maxWeight: 2500,
          ...getPricesWithoutVAT(4.99),
        },
        {
          minWeight: 2500,
          maxWeight: 5000,
          ...getPricesWithoutVAT(5.6),
        },
        {
          minWeight: 5000,
          maxWeight: 7,
          ...getPricesWithoutVAT(6.2),
        },
        {
          minWeight: 7,
          maxWeight: 10000,
          ...getPricesWithoutVAT(7.3),
        },
        {
          minWeight: 10000,
          maxWeight: 15000,
          ...getPricesWithoutVAT(8.9),
        },
        {
          minWeight: 15000,
          maxWeight: 20000,
          ...getPricesWithoutVAT(11.1),
        },
        {
          minWeight: 15000,
          maxWeight: 20000,
          ...getPricesWithoutVAT(13.5),
        },
      ],
    },
    {
      destinations: ['AT', 'DK', 'FI', 'PT', 'PL', 'SE'],
      rates: [
        {
          minWeight: 0,
          maxWeight: 500,
          ...getPricesWithoutVAT(5.6),
        },
        {
          minWeight: 500,
          maxWeight: 2500,
          ...getPricesWithoutVAT(5.75),
        },
        {
          minWeight: 2500,
          maxWeight: 5000,
          ...getPricesWithoutVAT(7),
        },
        {
          minWeight: 5000,
          maxWeight: 7,
          ...getPricesWithoutVAT(7.45),
        },
        {
          minWeight: 7,
          maxWeight: 10000,
          ...getPricesWithoutVAT(9.1),
        },
        {
          minWeight: 10000,
          maxWeight: 15000,
          ...getPricesWithoutVAT(11.15),
        },
        {
          minWeight: 15000,
          maxWeight: 20000,
          ...getPricesWithoutVAT(13.6),
        },
        {
          minWeight: 15000,
          maxWeight: 20000,
          ...getPricesWithoutVAT(16.5),
        },
      ],
    }
  ],
}